<template>
  <PageLayout class="accident-page">
    <AccidentFinally />
  </PageLayout>
</template>

<script>
import PageLayout from '@/shared/ui/layouts/page-layout/index.vue';
import AccidentFinally from '@/views/accident/finally.vue';

export default {
  name: 'AccidentFinallyPage',
  components: {
    PageLayout,
    AccidentFinally,
  },
};
</script>
